<template>
  <div class="menu">
    <ul class="list-group">
      <perfect-scrollbar>
        <div v-for="(menuSection, index) in menuItems" :key="index" v-show="menuSection.show">
          <a @click="menuCollapse(index)">
            <dt class="list-group-item noselect menu-header">
              <span v-if="menuSection['isCollapsed']">&#9662;</span>
              <span v-else>&#9652;</span>
              <span class="menu-item__label">{{$t(menuSection['name'])}}</span>
            </dt>
          </a>
          <transition-group name="menuItemAnimation">
            <router-link v-for="item in menuSection['items']"
                         v-show="!menuSection['isCollapsed'] && item.show"
                         :key="item.url"
                         :to="item.url"
                         tag="li"
                         class="list-group-item noselect"
                         active-class="active"
            >
              <a class="menu-item">
                <div>
                  <img class="menu-item__icon" :src=item.iconUrl>
                </div>
                <span class="menu-item__label">{{ $t(item.text)}}</span>
              </a>
            </router-link>
          </transition-group>
        </div>
      </perfect-scrollbar>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    methods: {
      menuCollapse(index) {
        this.$store.dispatch('menu/menuCollapse', index);
      }
    },
    computed: {
      ...mapState('menu', ['menuItems'])
    }
  }
</script>

<style scoped>
  .list-group {
    height: calc(100vh - 5px);
  }

  .list-group-item {
    transition: background 0.3s, color 0.3s;
    color: #000;
    background: #ececec;
    border-color: #b9b5b5;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
  }

  .list-group-item:hover {
    background: #cccaca;
  }

  .menu-item__icon {
    height: 31px;
  }

  .menu-item__label {
    font-size: 11px;
  }

  .list-group-item.active {
    font-weight: 700;
    background: #cccaca;
    border: 1px solid rgba(0, 0, 0, .125);
  }

  .list-group-item a {
    text-decoration: none;
    color: #735a5a;
  }

  .list-group-item.active a {
    color: #000;
  }

  .menu {
    padding-right: 1px;
    position: absolute;
    width: 90px;
    top: 0;
  }

  .menu-header {
    font-size: 9pt;
    text-align: left;
  }

  .menuItemAnimation-enter-active {
    transition: all .05s ease-in;
  }

  .menuItemAnimation-leave-active {
    transition: all .05s ease-out;
  }

  .menuItemAnimation-enter, .menuItemAnimation-leave-to {
    transform: translateY(-30px);
    opacity: 0;
    max-height: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/SideMenu.vue